(function () {
  window.ReigningWet = window.ReigningWet || {};

  if (window.ReigningWet.getLevelInfo) return;

  // Single source of truth for level thresholds — the backend has no level
  // table/function, so this is display-only math derived from xp totals,
  // never used to grant XP or badges. Shared by the account panel and the
  // public profile page so the numbers can't drift between the two.
  var LEVELS = [
    { name: 'Drizzle', minXp: 0 },
    { name: 'Making Waves', minXp: 100 },
    { name: 'Current Creator', minXp: 300 },
    { name: 'Heavy Motion', minXp: 750 },
    { name: 'Reigning', minXp: 1500 },
    { name: 'Hall of Wet', minXp: 3000 },
  ];

  function getLevelInfo(xp) {
    xp = xp || 0;
    var current = LEVELS[0];
    var next = null;

    for (var i = 0; i < LEVELS.length; i++) {
      if (xp >= LEVELS[i].minXp) {
        current = LEVELS[i];
        next = LEVELS[i + 1] || null;
      }
    }

    var progress = 1;
    if (next) {
      var span = next.minXp - current.minXp;
      progress = span > 0 ? (xp - current.minXp) / span : 1;
    }

    return {
      xp: xp,
      name: current.name,
      nextName: next ? next.name : null,
      nextMinXp: next ? next.minXp : null,
      progress: Math.max(0, Math.min(1, progress)),
    };
  }

  window.ReigningWet.LEVELS = LEVELS;
  window.ReigningWet.getLevelInfo = getLevelInfo;
  window.ReigningWet.BADGE_ORDER = ['profile_complete', 'first_wave', 'featured'];
})();
